import React, { useState } from "react";
import Chatbot from "./chatBot";
import TrainBot from "./Train";
import MessagesView from "./MessagesView";

function App() {
  const [screen, setScreen] = useState("chatbot");
  switch (screen) {
    case 'chatbot':
      return <Chatbot changeScreen={setScreen} />;
    case 'train':
      return <TrainBot changeScreen={setScreen} />;
  }
}

export default App;
